/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 */

import produce from 'immer';
import {LOADER_STATUS,SET_TABLE_DATA,SET_TOTAL_RECORD,ON_NOTIFY, ON_PROGRESS_DATA} from './constants';

// const data = [
//     {
//       file_id: "1697200240749",
//       file_name: "New File of Eway Bill.xlsx",
//       created_date: "2023-10-13T12:30:41.000Z",
//       record_count: 7,
//       upload_status: "Y",
//       pass: 6,
//       fail: 1,
//       total_record: 7,
//       dag_id: null,
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1697200178741",
//       file_name: "New File of Eway Bill.xlsx",
//       created_date: "2023-10-13T12:29:39.000Z",
//       record_count: 7,
//       upload_status: "Y",
//       pass: null,
//       fail: null,
//       total_record: null,
//       dag_id: null,
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1697199735731",
//       file_name: "New File of Eway Bill.xlsx",
//       created_date: "2023-10-13T12:22:16.000Z",
//       record_count: 7,
//       upload_status: "Y",
//       pass: null,
//       fail: null,
//       total_record: null,
//       dag_id: null,
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1697190245735",
//       file_name: "New File of Eway Bill.xlsx",
//       created_date: "2023-10-13T09:44:06.000Z",
//       record_count: 7,
//       upload_status: "Y",
//       pass: null,
//       fail: null,
//       total_record: null,
//       dag_id: null,
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1697190156866",
//       file_name: "New File of Eway Bill.xlsx",
//       created_date: "2023-10-13T09:42:37.000Z",
//       record_count: 7,
//       upload_status: "Y",
//       pass: null,
//       fail: null,
//       total_record: null,
//       dag_id: null,
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1691424205277",
//       file_name: "7082023213325_ewb_sample_5.xlsx",
//       created_date: "2023-08-07T16:03:25.000Z",
//       record_count: 4,
//       upload_status: "Y",
//       pass: 0,
//       fail: 4,
//       total_record: 4,
//       dag_id: "e621706b-bb5c-4c27-ab12-27ee557ee68e",
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1691412475836",
//       file_name: "7082023181755_ewb_sample_5.xlsx",
//       created_date: "2023-08-07T12:47:55.000Z",
//       record_count: 4,
//       upload_status: "Y",
//       pass: 0,
//       fail: 4,
//       total_record: 4,
//       dag_id: "a0f461f9-104c-4b04-bf66-be42e2a536dd",
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1690971157645",
//       file_name: "2082023154237_ewb_sample_5.xlsx",
//       created_date: "2023-08-02T10:12:37.000Z",
//       record_count: 4,
//       upload_status: "Y",
//       pass: 0,
//       fail: 4,
//       total_record: 4,
//       dag_id: "a4842b2d-d803-4126-bb34-fdffa9bc1e46",
//       status: "COMPLETED"
//     },
//     {
//       file_id: "1690542740646",
//       file_name: "28072023164220_ewb_sample_5.xlsx",
//       created_date: "2023-07-28T11:12:20.000Z",
//       record_count: 4,
//       upload_status: "Y",
//       pass: 0,
//       fail: 4,
//       total_record: 4,
//       dag_id: "25d1d1dd-ac08-40b2-8c99-bf64930a5277",
//       status: "COMPLETED"
//     }
//   ];

// The initial state of the App
export const initialState = {
  loaderStatus: false,
  tableData:[],
  total_record:0,
  progressData:[],
  status: false,
  msg: '',
};

/* eslint-disable default-case, no-param-reassign */
const vendorMasterReducer = (state = initialState, action) =>{
    switch (action.type) {
      case LOADER_STATUS:
        return {
          ...state,
          loaderStatus:action.loaderStatus
        }
      case SET_TABLE_DATA:
        return {
          ...state,
          tableData:action.tableData
        }
      case ON_PROGRESS_DATA:
        return {
          ...state,
          progressData:action.progressData
        }
      case SET_TOTAL_RECORD:
        return {
          ...state,
          total_record:action.total_record
        }
        case ON_NOTIFY:
          return {
            ...state,
            status: action.status,
            msg: action.msg,
          };
      default:
        return state;
    }
  };

export default vendorMasterReducer;
